import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cambiar_VisualizacionMenu } from '../../../../actions/generales/act_gen01';

class ItemMenu extends React.Component{
    constructor(props){
        super(props);        
        this.redirigirA = this.redirigirA.bind(this);
    }

    redirigirA(event){
        event.preventDefault();
        this.props.history.push(this.props.link_item);
        this.props.cambiar_VisualizacionMenu(false);        
    }

    render(){
        return(
            <li onClick={this.redirigirA}>
                <a href={this.props.link_item}>{this.props.nombre_item}</a>
            </li>
        );
  }
}

const mapStateToProps = ((state) => {
    return {isVisibleMenu: state.ui.isVisibleMenu}
});

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ cambiar_VisualizacionMenu }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemMenu));
